import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

const TableProfileSaveModal = ({ modalDetail, setModalDetail }) => {
  //Table State
  const { show, canEditCurrentProfile, onSave } = modalDetail

  const [saveType, setSaveType] = useState('')
  const [newProfileName, setNewProfileName] = useState('')

  useEffect(() => {
    if (!canEditCurrentProfile) {
      setSaveType('newProfile')
    }
  }, [canEditCurrentProfile])

  const closeModal = () => {
    setModalDetail({
      show: false,
    })
  }

  const handleConfirm = async () => {
    await onSave(saveType, newProfileName)
    setModalDetail((prev) => {
      return {
        ...prev,

        show: false,
      }
    })
  }

  return (
    <Modal isOpen={show} onClose={closeModal} size="md">
      <ModalOverlay />
      <ModalContent mt="3" maxW="1000px">
        <ModalHeader>Confirm Save Profile</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap="2" mb="4">
            <Text as="b">Save as new Profile / Save to existing Profile</Text>
            <Select
              value={saveType}
              onChange={(e) => setSaveType(e.target.value)}
              placeholder="Select option"
              disabled={!canEditCurrentProfile}
            >
              <option value="newProfile">New Profile</option>
              <option value="existingProfile">Existing Profile</option>
            </Select>

            {saveType === 'newProfile' && (
              <>
                <Text as="b">New Profile Name</Text>

                <Input value={newProfileName} onChange={(e) => setNewProfileName(e.target.value)}></Input>
              </>
            )}
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex gap="2">
            <Button colorScheme="teal" onClick={handleConfirm}>
              Confirm
            </Button>
            <Button colorScheme="gray" onClick={closeModal}>
              Close
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default TableProfileSaveModal
